module.exports = __webpack_public_path__ + "static/img/illustratepic_02_kr.dd22d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustratepic_02_kr.png
// module id = Syk3
// module chunks = 1